import { NavLink } from "react-router-dom";

export default function PageNotFound() {
  return (
    <div>
      <h1>404 - Page Not Found</h1>
      <p><NavLink to="/login">Click here</NavLink> to go to login page</p>
    </div>
  );
}